export default __webpack_public_path__ + "static/media/in-progress-icon.9a065186.svg";